import { SalesReportDateSelection } from '../../enums/salesReportDateSelection'
import { useSalesReportFilters } from '../useSalesReportFilters'
import { useFetchSalesOverviewReport } from './useFetchSalesOverviewReport'

export const useSalesOverviewReport = () => {
  const [{ dateSelection = SalesReportDateSelection.Issue, period }] = useSalesReportFilters()
  const { salesOverviewReport, isLoading } = useFetchSalesOverviewReport({ dateSelection, period })

  return { dateSelection, salesOverviewReport, isLoading }
}
